// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination-container-EMi8Y {
  padding: 0px 20px;
}

.pagination-content-zGu8J {
  display: flex;
  align-items: center;
  position: relative;
  color: rgba(0, 0, 0, 0.8);
  font-size: 14px;
  border-top: 1px solid var(--border-color);
  padding: 8px 0px;
}

.pagination-size-lctP2 {
  display: flex;
  align-items: center;
  margin: 0px 32px 0px auto;
}

.pagination-select_container-HICzP {
  width: fit-content;
  margin-left: 16px;
}

.pagination-select_input-LZRK_ {
  height: 28px;
  padding: 0px 2px 0px 6px;
}

.pagination-select_value-RVaQa {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.8);
}

.pagination-select_expandMoreIcon-xOtIF {
  --size: 20px;
  color: rgba(0, 0, 0, 0.6);
  margin-left: 2px;
}

.pagination-selectOption_container-yhxJN {
  padding: 4px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.8);
}

.pagination-page-v4bdr {
  display: flex;
  align-items: center;
}

.pagination-icon-Hr7m_ {
  --size: 22px;
  color: rgba(0, 0, 0, 0.6);
  border-radius: 4px;
  margin: 0px 4px;
}

.pagination-icon-Hr7m_:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

.pagination-icon-Hr7m_:active {
  background-color: rgba(0, 0, 0, 0.08);
}

.pagination-iconDisabled-bF2e4 {
  color: rgba(0, 0, 0, 0.3);
  pointer-events: none;
}

.pagination-iconDisabled-bF2e4:hover {
  background-color: transparent;
}

.pagination-divider-oEJB7 {
  height: 1px;
  position: absolute;
  top: 0px;
  left: 20px;
  right: 20px;
  background-color: var(--border-color);
}`, "",{"version":3,"sources":["webpack://./../core/src/components/pagination/pagination.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,qCAAqC;AACvC","sourcesContent":[".container {\n  padding: 0px 20px;\n}\n\n.content {\n  display: flex;\n  align-items: center;\n  position: relative;\n  color: rgba(0, 0, 0, 0.8);\n  font-size: 14px;\n  border-top: 1px solid var(--border-color);\n  padding: 8px 0px;\n}\n\n.size {\n  display: flex;\n  align-items: center;\n  margin: 0px 32px 0px auto;\n}\n\n.select_container {\n  width: fit-content;\n  margin-left: 16px;\n}\n\n.select_input {\n  height: 28px;\n  padding: 0px 2px 0px 6px;\n}\n\n.select_value {\n  font-size: 14px;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n.select_expandMoreIcon {\n  --size: 20px;\n  color: rgba(0, 0, 0, 0.6);\n  margin-left: 2px;\n}\n\n.selectOption_container {\n  padding: 4px;\n  font-size: 14px;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n.page {\n  display: flex;\n  align-items: center;\n}\n\n.icon {\n  --size: 22px;\n  color: rgba(0, 0, 0, 0.6);\n  border-radius: 4px;\n  margin: 0px 4px;\n}\n\n.icon:hover {\n  background-color: rgba(0, 0, 0, 0.04);\n}\n\n.icon:active {\n  background-color: rgba(0, 0, 0, 0.08);\n}\n\n.iconDisabled {\n  color: rgba(0, 0, 0, 0.3);\n  pointer-events: none;\n}\n\n.iconDisabled:hover {\n  background-color: transparent;\n}\n\n.divider {\n  height: 1px;\n  position: absolute;\n  top: 0px;\n  left: 20px;\n  right: 20px;\n  background-color: var(--border-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `pagination-container-EMi8Y`,
	"content": `pagination-content-zGu8J`,
	"size": `pagination-size-lctP2`,
	"select_container": `pagination-select_container-HICzP`,
	"select_input": `pagination-select_input-LZRK_`,
	"select_value": `pagination-select_value-RVaQa`,
	"select_expandMoreIcon": `pagination-select_expandMoreIcon-xOtIF`,
	"selectOption_container": `pagination-selectOption_container-yhxJN`,
	"page": `pagination-page-v4bdr`,
	"icon": `pagination-icon-Hr7m_`,
	"iconDisabled": `pagination-iconDisabled-bF2e4`,
	"divider": `pagination-divider-oEJB7`
};
export default ___CSS_LOADER_EXPORT___;
